const state = {
    clients: [],
    departments: [],
    districts: [],
    cultivation_types: [],
    warehouses: [],
    safras: [],
    protocols: [
        {
            id: 'PROTOCOLO_PARAGUAI',
            name: 'Protocolo EUDR'
        }
    ],
    properties: [],
    form: {
        contract_data: {
            contract_number: '',
            volume: undefined,
            cultivation_id: 'SOJA',
            safra: '',
            warehouse_id: '',
            department: '',
            district: '',
            delivery_location_id: '',
            client_id: '',
            contract_date: ''
        },
        protocol_id: undefined,
        properties: []
    },
    report: {
        contract_number: '',
        volume: undefined,
        cultivation_id: '',
        safra: '',
        warehouse_id: '',
        delivery_location_id: '',
        client_id: '',
        contract_date: '',
        properties: []
    },
    reportList: [],
    summary: {
        contracts_total: 0,
        volume_total: 0,
        properties_total: 0,
        contracts_reproved_total: 0,
        total_waiting_contracts: 0
    },
    filter: {
        page: 0,
        size: 10,
        contract_number: '',
        status: [],
        client: '',
        safra: '',
        cultivations: [],
        loading: false
    },
    file: {
        id: 0,
        blobReference: '',
        type: '',
        createdAt: '',
        active: false
    },
    files: [],
    availableBalance: {
        territory_id: '',
        ton: '',
        sc: '',
        valid: false
    }
};

export default state;
